export default {
  namespaced: true,
  state: () => ({
    authenticated: false,
    environment: {},
    token: null,
    id_token: null,
    sessionId: -1
  }),
  getters: {
    isAuthenticated: s => s.authenticated,
    currentContext: (state) => {
      if (!state.token) return null;
      const decoded = Buffer.from(state.token.split('.')[1], 'base64').toString('utf8')
      return JSON.parse(decoded)
    },
    getEnvironment: (state) => {
      return state.environment
    },
    userId: (state, getters) => parseInt(getters.currentContext.UserId),
    environmentId: s => parseInt(s.environment.nId),
    sessionId: (state) => parseInt(state.sessionId),
    accessToken: (state) => state.token,
    id_token: (state) => state.id_token
  },
  mutations: {
    setAuth (state, { sessionId,  token, id_token }) {
      state.sessionId = sessionId
      state.token = token
      state.id_token = id_token
      state.authenticated = true
    },
    setEnvironment (state, payload) {
      state.environment = payload
    },
    logout (state) {
      state.token = null
      state.authenticated = false
    }
  },
  actions: {
    async login ({ commit }, credentials) {
      // const token = await api.login(credentials)
      // commit('SET_AUTH', { token })
    }
  }
}
